<template>
  <div id="checkout">
    <section v-show="!loading">
      <div class="payment-info">
        <div id="iban-element" class="field"></div>
      </div>

      <div class="payment-button-wrapper">
        <v-btn
          @click="processPayment"
          color="success"
          class="payment-button"
          ref="submitButton"
          :disabled="payButtonDisabled || !this.payButtonEnabled"
          >{{ buttonLabel }}</v-btn
        >
        <div class="payment-button__pulse"></div>
      </div>
    </section>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="green"
    ></v-progress-circular>

    <div id="card-errors" ref="paymentErrors" class="element-errors hide">
      {{ stripeValidationError }}
    </div>
  </div>
</template>

<script>
import stripeMixin from '../../mixins/stripe';

export default {
  name: 'stripe-iban',

  props: {
    payButtonEnabled: {
      type: Boolean,
      default: false,
    },
    orderedItem: {
      type: Object,
      default: () => {},
    },
    customerData: {
      type: Object,
      default: () => {},
    },
  },

  mixins: [stripeMixin],

  data() {
    return {
      payButtonDisabled: false,
      ibanElement: null,
      stripeValidationError: '',
      stripePaymentIntentSecret: undefined,
      loading: false,
    };
  },

  watch: {
    orderedItem(val) {
      this.updateButtonLabel(val, 'SEPA Überweisung');
    },
  },

  methods: {
    createIbanElement() {
      // Create an instance of Elements.
      const elements = this.stripe.elements();

      // Prepare the styles for Elements.
      const style = {
        base: {
          iconColor: '#666ee8',
          color: '#31325f',
          fontWeight: 400,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '15px',
          '::placeholder': {
            color: '#aab7c4',
          },
          ':-webkit-autofill': {
            color: '#666ee8',
          },
        },
      };

      // Create a IBAN Element and pass the right options for styles and supported countries.
      const ibanOptions = {
        style,
        supportedCountries: ['SEPA'],
      };
      this.ibanElement = elements.create('iban', ibanOptions);

      // Mount the IBAN Element on the page.
      this.ibanElement.mount('#iban-element');

      // Monitor change events on the IBAN Element to display any errors.
      this.ibanElement.on('change', ({ error, bankName }) => {
        if (error) {
          this.payButtonDisabled = false;
          this.stripeValidationError = error.message;
          this.$refs.paymentErrors.classList.remove('hide');
        } else {
          if (bankName) {
            this.updateButtonLabel(this.orderedItem, 'SEPA Überweisung', bankName);
          }
          this.$refs.paymentErrors.classList.add('hide');
        }
        // Re-enable the Pay button.
        this.payButtonDisabled = false;
      });
    },

    async processPayment() {
      console.log('pay iban');
      this.payButtonDisabled = true;
      this.$refs.submitButton.textContent = 'Processing…';
      this.$gtm.push({ event: 'checkout', product_name: this.orderedItem.name });

      const paymentObj = {
        payment_method: {
          sepa_debit: this.ibanElement,
          billing_details: {
            name: this.customerData.name,
            email: this.customerData.email,
          },
        },
      };

      if (this.customerData && this.customerData.email) {
        paymentObj.receipt_email = this.customerData.email;
      }

      const confirmation = await this.stripe.confirmSepaDebitPayment(
        this.stripePaymentIntentSecret,
        paymentObj,
      );

      if (confirmation.error) {
        this.payButtonDisabled = false;
        this.stripeValidationError = confirmation.error.message;
        this.$refs.paymentErrors.classList.remove('hide');
      } else {
        this.$refs.paymentErrors.classList.add('hide');
        this.$emit('payment-successful', {
          paidPlan: this.orderedItem,
          paymentId: confirmation.paymentIntent.id,
          paidBy: 'iban',
        });
        console.log('success');
      }
    },
  },

  async mounted() {
    this.loading = true;
    this.payButtonDisabled = true;
    const clientSecret = await this.createPaymentIntent(this.orderedItem);
    this.stripePaymentIntentSecret = clientSecret;

    this.createIbanElement();
    this.updateButtonLabel(this.orderedItem, 'Iban');
    this.payButtonDisabled = false;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '@/styles/blue-ring.scss';

.payment-info {
  margin: 15px auto;
  /* width: 90%; */
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 2px 3px 3px 2px rgba(0, 0, 0, 0.25);
}

.payment-button-wrapper {
  margin: 15px auto;
  width: 90%;
  position: relative;
  text-align: center;
}

.payment-button {
  // margin: 15px auto;
  width: 100%;
  padding: 8px;
  border-radius: 15px;
  @include mainLinearGradient;
  color: white;
  margin: 0 !important;
  font-weight: bold;

  &__pulse {
    @include pulse3;
    position: absolute;
    top: -1px;
    height: 40px;
    width: 100%;
    border-radius: 15px;
    pointer-events: none; // pass through click event
  }
}

.hide {
  display: none;
}
</style>
